<template lang="pug">
  .build
    .build_line
      .line_title {{bdata.build}}
      .line_body
        .line_body_de(v-for="(unitInfo,index) in bdata.unitInfoList" :key="index")
          .line_body_left {{unitInfo.unit}}
          .line_body_right
            .half_right(v-for="(device,ind) in unitInfo.deviceInfoList" :key="device.elevatorNo + '__' + ind")
              template {{device.elevatorNo}}（承诺
              span.bold_bla {{normalPlayCount}}次
              |  实播
              span.bold_bla {{device.activePlayCount}}次
              |  成功率
              span.bold_red {{((device.activePlayCount/normalPlayCount)*100).toFixed(2)}}%
              | ）
</template>

<script>
export default {
    name: "MonitDetailBuild",
    props: {
        bdata: {
            type: Object,
            default () {
                return {}
            }
        },
        normalPlayCount: {
            type: Number,
            default: 0
        }
    }
}
</script>

<style lang="sass" scoped>
.bold_bla
  font-weight: 600
  color: #666666
.bold_red
  font-weight: 600
  color: #FF3973
.build
  overflow: hidden
  background: #f5f5f5
  margin-bottom: 10px
  .build_line
    margin-bottom: 10px
    .line_title
      height: 40px
      padding: 10px
      font-size: 14px
      font-weight: 400
      color: rgba(40, 39, 41, 1)
      line-height: 20px
      border-bottom: 1px solid #E9E9E9
    .line_body
      font-size: 12px
      clear: both
      .line_body_de
        .line_body_left
          float: left
          width: 20%
          padding-left: 10px
          border-top: 1px solid #E9E9E9
          min-height: 30px
        .line_body_right
          float: right
          width: 80%
          border-left: 1px solid #E9E9E9
          .half_right
            height: 30px
            // padding-top: 5px
            padding: 5px 8px 0
            float: left
            min-width: 50%
            border-right: 1px solid #E9E9E9
            border-bottom: 1px solid #E9E9E9
            text-align: center
      .line_body_de:first-child
        .line_body_left:first-child
          border-top: 0
      .line_body_de:last-child
        .line_body_right
          .half_right
            border-bottom: 0
</style>
